module.exports = __webpack_public_path__ + "media/images/tutorialSlide__screenshot2-e8f5618f89d654a4b0708d1113f98674.png";